import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LINKS = [
  { label: "Manifesto", id: "manifesto" },
  { label: "Collection", id: "collection" },
  { label: "Showpieces", id: "showpieces" },
  { label: "Shop the Look", id: "shop-the-look" },
  { label: "Hampers", id: "hampers" },
  { label: "Diwali Edition", id: "essence" },
  { label: "Build a Hamper", id: "builder" },
  { label: "Enquire", id: "enquire" },
];

const DESKTOP_LINKS = LINKS.filter((l) =>
  ["collection", "showpieces", "hampers", "essence", "builder"].includes(l.id)
);

export const Header = ({ scrollTo }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => { setOpen(false); scrollTo(id); };

  return (
    <motion.header
      data-testid="site-header"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,border-color,padding] duration-500 ${
        scrolled ? "bg-[#F7F5F0]/80 backdrop-blur-xl border-b border-[#e2dbd0] py-3" : "py-6 border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 flex items-center justify-between">
        <button data-testid="logo-home" onClick={() => go("top")} className="flex items-center gap-3 group">
          <img src="/logo.png" alt="Pageshier Casa" className="h-11 w-11 object-contain rounded-full ring-1 ring-[#e2dbd0] bg-white" />
          <span className="font-serif text-lg md:text-xl tracking-wide text-[#2c2826] leading-none">
            PAGESHIER<span className="text-[#985F47]"> CASA</span>
          </span>
        </button>

        <nav className="hidden md:flex items-center gap-9">
          {DESKTOP_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="relative text-sm text-[#5a5451] hover:text-[#2c2826] transition-colors duration-300 group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-[#985F47] transition-[width] duration-300 group-hover:w-full" />
            </button>
          ))}
          <button
            data-testid="nav-cta"
            onClick={() => go("enquire")}
            className="rounded-full bg-[#2c2826] text-[#F7F5F0] text-sm px-5 py-2.5 hover:bg-[#985F47] transition-colors duration-300"
          >
            Get in touch
          </button>
        </nav>

        <button data-testid="menu-toggle" className="md:hidden text-[#2c2826]" onClick={() => setOpen((o) => !o)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            className="md:hidden overflow-hidden bg-[#F7F5F0]/95 backdrop-blur-xl border-t border-[#e2dbd0]"
          >
            <div className="px-6 py-4 flex flex-col gap-4">
              {LINKS.map((l) => (
                <button key={l.id} data-testid={`nav-m-${l.id}`} onClick={() => go(l.id)}
                  className="text-left font-serif text-xl text-[#2c2826]">{l.label}</button>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
